export interface ProductModel {
  id: number;
  productId: number;
  isKit: boolean;
  kitSize?: number; // Size of the kit, if applicable
  name: string;
  unitPrice: number;
  finalPrice: number; // Final price after markup
  originalUnitPrice: number; // Original unit price before any discounts
  description: string;
  color: string;
  coverType: CoverEnum;
  quantity: number;
  imageHash: string;
  totalPrice: number;
  totalItemDiscount: number; // Total discount applied to this item
  discountPercentage: number; // Discount percentage, if applicable
}

export enum CoverEnum {
  Paperback,
  Hardback
}
